/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAccountsResponseItem } from './search-accounts-response-item';


export interface SearchAccountsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchAccountsResponseItem> | null;
}

